export default __webpack_public_path__ + "static/favicon-70fd4031c9365f1e168a8781a72a7e59.ico";